<app-yearly-balance-chart [data]="data()" [loading]="resource.isLoading()"></app-yearly-balance-chart>
